import update from 'react/lib/update';
import * as actionConst from './actions'

export const initState = {
    headingSubtexts: [
        { heading: '', subtext: '' }
    ],
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionConst.ADD_HEADINGSUBTEXT:
            return update(state, {
                headingSubtexts: {
                    $push: [action.headingSubtextObj]
                }
            })
        case actionConst.UPDATE_HEADING:
            return update(state, {
                headingSubtexts: {
                    [action.index]: {
                        heading: {
                            $set: action.text
                        }
                    }
                }
            })
        case actionConst.UPDATE_SUBTEXT:
            return update(state, {
                headingSubtexts: {
                    [action.index]: {
                        subtext: {
                            $set: action.text
                        }
                    }
                }
            })
        case 'KILL_WORKPLACE':
            return initState
        default:
            return state
    }
}

export default reducer



// WEBPACK FOOTER //
// ./src/App/HeadingSubtext/reducer.js